import styled from 'styled-components';

export const ReportAnIssueWrapper = styled.div`
    display: inline-grid;
    padding: 10px 20px;
`;

// TODO: All of this should come from a "Action" component.
export const Interior = styled.div`
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    padding: 9px 13px;
    height: 36px;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: -0.1px;
    color: white;
    border: 1px solid rgba(18, 8, 40, 0.1);
    border-bottom-width: 1px;
    border-radius: 100px;
    background: linear-gradient(68deg, #1d1b2b, #151327),
        linear-gradient(
            323deg,
            rgba(255, 255, 255, 0.4),
            rgba(255, 255, 255, 0.08),
            rgba(255, 255, 255, 0.08),
            rgba(255, 255, 255, 0.24),
            rgba(255, 255, 255, 0.08),
            rgba(255, 255, 255, 0.08),
            rgba(255, 255, 255, 0.4)
        );
    background-clip: padding-box, border-box;
    background-origin: padding-box, border-box;
`;
